// getSignedUrl.js
import { GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { s3Client } from './s3Client';

export const generatePresignedUrl = async (bucketName, objectKey) => {
    const command = new GetObjectCommand({
        Bucket: bucketName,
        Key: objectKey,
    });

    const signedUrl = await getSignedUrl(s3Client, command, {
        expiresIn: 60 * 5, // 5 minutes
    });

    return signedUrl;
};
